module.exports = __webpack_public_path__ + "730e62c7c5aa12ba3ecab010bb7ac03f.png";